import * as angular from "angular";
import { Endpoints } from "../../shared/config/constant.module";
import { PlantFeatureSettingPayload } from '../../models/plants/plantFeatureSettings';
import HttpServiceName, { HttpService } from "../http/http.service";
let requires = [HttpServiceName];

export interface PlantFeatureSettingsServiceInterface {
  get(plantId: string): angular.IPromise<PlantFeatureSettingPayload>;
  post(setting: PlantFeatureSettingPayload): angular.IPromise<any>;
  put(setting: PlantFeatureSettingPayload): angular.IPromise<any>;
}

export class PlantFeatureSettingsService implements PlantFeatureSettingsServiceInterface {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string): angular.IPromise<PlantFeatureSettingPayload> {
    let url = Endpoints.PLANT_FEATURE_SETTINGS + '/' + plantId;
    return this.httpService.get<PlantFeatureSettingPayload>(url);
  }

  post(setting: PlantFeatureSettingPayload): angular.IPromise<any> {
    let url = Endpoints.PLANT_FEATURE_SETTINGS;
    return this.httpService.post(url, setting);
  }

  put(setting: PlantFeatureSettingPayload): angular.IPromise<any> {
    let url = Endpoints.PLANT_FEATURE_SETTINGS;
    return this.httpService.put(url, setting);
  }
}

export default angular
  .module('aps.services.plantFeatureSettings', requires)
  .service('plantFeatureSettingsService', PlantFeatureSettingsService)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/plant/plantFeatureSettings.service.ts